import { LANGUAGES } from "@/constants/util.constants";
import { sendUpdateUserPreferredLanguage } from "@/models/socket/user.model";
import { AppContext } from "@/services/AppContext/appContext";
import { Label } from "@/shadcn/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shadcn/components/ui/select";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils.util";
import React, { useContext, useState } from "react";

type PreferLangProps = {
  initialValue: string;
};

const PreferLang: React.FC<PreferLangProps> = ({ initialValue }) => {
  const [submitting, setSubmitting] = useState(false);
  const [preferredLanguage, setPreferredLanguage] = useState<string>(
    initialValue.toLowerCase()
  );
  const { setUserShouldUpdateAccount } = useContext(AppContext);

  async function onLanguageChange(language: string) {
    setPreferredLanguage(language);
    setSubmitting(true);
    const response = await sendUpdateUserPreferredLanguage(language);
    if (response.rStatus === "error") {
      setSubmitting(false);
      setPreferredLanguage(initialValue.toLowerCase());
      genericFailureToast(
        response.rData ||
          "Failed to update preferred language. Please try again later."
      );
      return;
    }

    setSubmitting(false);
    genericSuccessToast("Preferred language updated successfully");
    setUserShouldUpdateAccount(false);
  }

  return (
    <div className="flex flex-row flex-wrap items-center gap-2">
      <Label className="flex max-w-full flex-row flex-wrap text-base font-semibold whitespace-nowrap">
        <div>Preferred Language</div>
        <Select
          value={preferredLanguage}
          onValueChange={(value: string) => onLanguageChange(value)}
          disabled={submitting}
        >
          <SelectTrigger className="w-full max-w-full truncate">
            <SelectValue placeholder="Select language" />
          </SelectTrigger>
          <SelectContent>
            {LANGUAGES.map((lang) => (
              <SelectItem
                key={lang.code}
                value={lang.code}
                className={`w-auto max-w-full truncate overflow-hidden ${submitting ? "cursor-not-allowed opacity-50 duration-500" : ""}`}
              >
                {lang.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Label>
    </div>
  );
};

export default PreferLang;
